import axios from 'axios';
import { BASE_URL } from './urls';

export const getToken = () => {
  //get token from localstorage
  let token = localStorage.getItem('access_token');
  return token;
}

export const refreshToken = () => {
  
}

export const axiosInstance = () => {
  var AUTH_TOKEN = getToken();
  const instance = axios.create({
    baseURL: BASE_URL,
    headers: {
      Accept: 'application/json',
      Authorization: "Token " + AUTH_TOKEN,
    }
  });

  return instance;
}

/* file upload */
export const axiosFileUpload = () => {
  var AUTH_TOKEN = getToken();
  const instance = axios.create({
    baseURL: BASE_URL,
    headers: {
      Accept: '*/*',
      Authorization: 'Token ' + AUTH_TOKEN,
      'Content-Type': 'multipart/form-data'
    }
  });

  return instance;
}
